export enum DataExchangePeriodType {
    Period = 1,
    Range
}
